import '../librairies/responsiveslides'
import 'responsive-slides/responsiveslides.css'

const sliders = document.querySelectorAll('.rslides')
sliders.forEach(sliderHTMLElement => {

    // Paramètre par défaut pour les slides
    const defaultParams = {
        timeout: 6000,
        waitingBeforeStart: 10, //Temps d'attente de 6 secondes avant de démarrer le slider
        pager: true,
    }

    // Récupère les data-attribut sur l'objet déclarant le slider et créer un objet en fonction du nom des attribut
    const dataParams = Object.assign({}, sliderHTMLElement.dataset)
    for (const [key, value] of Object.entries(dataParams)) {

        if(value === "true" || value === "false")
        {
            dataParams[key] = (dataParams[key] === "true")
        }
    }

    $(sliderHTMLElement).responsiveSlides(
        Object.assign({}, defaultParams, dataParams)
    );
})

